import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types';
import { Route, useHistory, Link } from 'react-router-dom';

// Redux
import { connect } from 'react-redux';

// Actions
import { toggleProfileModal, setPage } from '../actions/navActions';

// Components - imported

// Sliding Edit Profile Form
import ProfileForm from '../components/Profile/ProfileModal/ProfileForm';

const SetUpProfile = ({ 
    toggleProfileModal, 
    setPage, 
    post: {
        post
    },
    auth: {
        profileUser
    }
}) => {

    // Initialize the state for the window width
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Get the current URL and extract the "goBack" parameter
    const url_filter = (window.location.href);
    const url = new URL(url_filter);
    const previousUrl = url.searchParams.get("goBack");

    let history = useHistory();

    useEffect(() => {
        // Add an event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());
        
        // Set the page to 'set-up'
        setPage('set-up')

        // Clean up the event listener on component unmount
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    // Update the window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    // Determine if the window is in mobile or tablet view
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1000;

    // Redirect to a specific page if not in mobile view and there is a previousUrl value.
    // Also add a trigger to pop up profile setUp modal on page load using localStorage
    if(!isMobile) {
   
        if(previousUrl !== null) {
            localStorage.setItem("trigger_modal", "profile_modal");
            if(previousUrl === 'create' || previousUrl === 'create_home') {
                history.push(`/home`);
            } else if(previousUrl === 'detail' || previousUrl === 'create_detail') {
                if(post) {
                    history.push(`/post/${post._id}`);
                } else {
                    history.push(`/home`);
                }
            } else if(previousUrl === 'create_profile') {
                if(profileUser) {
                    history.push(`/user/${profileUser._id}`); 
                } else {
                    history.push(`/home`);
                }
            } else if(previousUrl === 'comment') {
                if(post) {
                    history.push(`/post/${post._id}`);
                } else {
                    history.push(`/home`);
                }
            } else {
                history.push(`/${previousUrl}`);
            }
        }
    }

    return (
        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '20px 20px 0'}}>
            <ProfileForm page previousUrl={previousUrl} history={history} post={post} />
        </div>
    )
}

SetUpProfile.propTypes = {
    // Prop type validation for function to toggle the profile modal
    toggleProfileModal: PropTypes.func.isRequired,
    // Prop type validation for function to Set the Page
    setPage: PropTypes.func.isRequired,
    post: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
}

const mapStateToProps = state => ({
    post: state.post,
    auth: state.auth
});

export default connect(mapStateToProps, { 

    // Connecting actions to the component
    toggleProfileModal, 
    setPage 
})(SetUpProfile);
